import React from 'react';
import { string, shape } from 'prop-types';
import { useStyle } from '@magento/venia-ui/lib/classify';
import defaultClasses from './sharer.module.css';
import Icon from '../Icon';

import { Share2 as ShareIcon } from 'react-feather';

/**
 * A component for buttons.
 *
 * @typedef Sharer
 * @kind functional component
 *
 * @param {props} props React component props
 *
 * @returns {React.Element} A React component that displays a button to share content
 */
const Sharer = props => {
    const { title, url, text, buttonTitle, buttonText } = props;

    if (!url || !navigator.share) {
        console.log('Sharing not supported');
        return null;
    }

    const classes = useStyle(defaultClasses, props.classes);

    function share() {
        navigator.share({
            title: title,
            url: url,
            text: text
        });
    }

    return (
        <span
            onClick={share}
            className={classes.root}
            title={buttonTitle}
            className={classes.root}
        >
            <Icon
                src={ShareIcon}
                attrs={{ width: 24, strokeWidth: 1 }}
                onClick={share}
                title={buttonTitle}
                className={classes.icon}
            />
            {buttonText}
        </span>
    );
};

Sharer.propTypes = {
    clases: shape({
        root: string,
        icon: string
    }),
    url: string.isRequired,
    title: string,
    text: string,
    buttonTitle: string,
    buttonText: string
};

Sharer.defaultProps = {
    buttonTitle: _('Share this element'),
    buttonText: _('Share this!')
};

export default Sharer;
